"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxMintButton = exports.MYSTERY_BOX_MINT_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const mintBox_json_1 = __importDefault(require("@framework/abis/json/ERC721MysteryBoxSimple/mintBox.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const hooks_1 = require("../../../../../hooks");
const dialog_1 = require("./dialog");
exports.MYSTERY_BOX_MINT_DIALOG_KEY = "mysteryBoxMint";
const MysteryBoxMintButton = (props) => {
    const { className, mystery: { id, template }, disabled, variant, } = props;
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.MINTER_ROLE, template?.contract?.id);
    const handleMintToken = () => {
        openFormDialog(`${exports.MYSTERY_BOX_MINT_DIALOG_KEY}.${id}`, void 0, "button");
    };
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const content = (0, exchange_1.convertDatabaseAssetToChainAsset)(values.mysteryBox.content.components);
        return writeContractAsync({
            address: template.contract.address,
            abi: mintBox_json_1.default,
            functionName: "mintBox",
            args: [values.account, values.mysteryBox.templateId, content],
        });
    });
    const handleMintTokenConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleMintToken, icon: icons_material_1.AddCircleOutline, message: "form.buttons.mintToken", className: className, dataTestId: "MysteryBoxMintButton", disabled: disabled || !hasPermission, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.MysteryBoxMintDialog, { onExternalConfirm: handleMintTokenConfirmed, open: formDialogUniqueKey === `${exports.MYSTERY_BOX_MINT_DIALOG_KEY}.${id}.${mode}`, initialValues: {
                    contractId: template.contractId,
                    mysteryId: 0,
                    account,
                } })] }));
};
exports.MysteryBoxMintButton = MysteryBoxMintButton;
//# sourceMappingURL=index.js.map